import React from 'react';
import '../css/Rules.css'
import Navigation from './Navigation';

const Rules = () => {
  return (
    <div className="rules-page">
      <Navigation />
      <header className="rules-header">
        <h1>Book Bingo</h1>
        <h2>How to Play</h2>
      </header>

      <div className="rules-content">
        <div className="rules-section">
          <h3>Getting Started</h3>
          <p>
            Each square on your bingo card represents a unique reading challenge. 
            These challenges are designed to help you explore different types of books and reading experiences.
          </p>
        </div>

        <div className="rules-section">
          <h3>Completing Challenges</h3>
          <p>
            When you finish reading a book that matches a challenge, click on the corresponding square 
            and search for the book to mark it as complete.
          </p>
        </div>

        <div className="rules-section">
          <h3>Wildcard Feature</h3>
          <p>
            To help you complete the grid, you can use one book as a wildcard! This means you can use the same book 
            to complete two different challenges. However, you can only use this feature once per grid - choose your 
            wildcard book wisely!
          </p>
        </div>

        <div className="rules-section">
          <h3>Earning Points</h3>
          <p>
            You can earn points by completing:
            <ul>
              <li>A challenge (10 points)</li>
              <li>Vertical lines (50 points)</li>
              <li>Horizontal lines (50 points)</li>
              <li>Diagonal lines (50 points)</li>
              <li>The entire card (100 points)</li>
            </ul>
            The more lines you complete, the more points you earn!
          </p>
        </div>

        <div className="rules-section">
          <h3>Tracking Progress</h3>
          <p>
            Keep track of your reading journey on the leaderboard. Challenge yourself to complete 
            the entire card and compete with other readers in the community.
          </p>
        </div>

        <div className="rules-section">
          <h3>Support the Developers</h3>
          <p>
            If you're enjoying Book Bingo and would like to support its development, consider buying us a coffee!
          </p>
          <a 
            href="https://www.buymeacoffee.com/jfirth20011" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="coffee-link"
          >
            <img 
              src="https://cdn.buymeacoffee.com/buttons/v2/default-yellow.png" 
              alt="Buy Me A Coffee" 
              width="217"
              height="60"
            />
          </a>
        </div>
      </div>
    </div>
  );
};

export default Rules;

